// extracted by mini-css-extract-plugin
export default {"card":"flippableCard_card__KYM8L","cardContent":"flippableCard_cardContent__2-QgC","front":"flippableCard_front__HJnwG","back":"flippableCard_back__J8S7T"};